import React, {HTMLAttributes} from 'react';
import inputStyles from '../../../_common/styles/commonInput.module.scss';

interface EditableFileNameProps extends HTMLAttributes<HTMLInputElement> {
  fileName: string,
}

export const EditableFileName = ({fileName = '', ...rest}: EditableFileNameProps) => {
  const [name] = fileName.split('.');

  return (
    <input
      type="text"
      defaultValue={name || ''}
      className={inputStyles.input}
      {...rest}
    />
  );
};